class HCLinks {
  constructor() {
    this.init();
  }

  init() {
    this.setupVideoButtons();
    this.setupVideoPopup();
  }

  setupVideoButtons() {
    const videoButtons = document.querySelectorAll('.hc-link-item--clickable[data-youtube-id]');
    
    videoButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const youtubeId = button.getAttribute('data-youtube-id');
        if (youtubeId) {
          this.openVideoPopup(youtubeId);
        }
      });
    });
  }

  setupVideoPopup() {
    const popup = document.getElementById('video-popup');
    const overlay = popup?.querySelector('.video-popup__overlay');
    const closeBtn = popup?.querySelector('.video-popup__close');

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        // Only close if clicking directly on the overlay, not on the video content
        if (e.target === overlay) {
          this.closeVideoPopup();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.closeVideoPopup();
      });
    }

    // Close popup on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeVideoPopup();
      }
    });
  }

  openVideoPopup(youtubeId) {
    const popup = document.getElementById('video-popup');
    const iframe = document.getElementById('video-iframe');
    
    if (popup && iframe) {
      // Set the YouTube embed URL with proper embed parameters
      const embedUrl = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&enablejsapi=1&origin=${window.location.origin}&playsinline=1&controls=1&disablekb=0&fs=1`;
      iframe.src = embedUrl;
      
      // Show the popup
      popup.style.display = 'flex';
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      // Focus management for accessibility
      popup.focus();
    }
  }

  closeVideoPopup() {
    const popup = document.getElementById('video-popup');
    const iframe = document.getElementById('video-iframe');
    
    if (popup && iframe) {
      // Hide the popup
      popup.style.display = 'none';
      
      // Stop the video by clearing the src
      iframe.src = '';
      
      // Restore body scroll
      document.body.style.overflow = '';
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HCLinks();
});

// Also initialize if script is loaded after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HCLinks();
  });
} else {
  new HCLinks();
}
